import { defineComponent as _defineComponent } from 'vue'
import { ref, provide, computed, reactive, watch, Ref } from 'vue';
import SvgIcon from './SvgIcon.vue';
import ArrowStrokeSelectDownIcon from '../icons/ArrowStrokeSelectDownIcon.vue';
import useZIndex from '../../../hooks/useZIndex';
import '../../../directives/vClickOutside';

interface Props {
  value: string | number | boolean | object,
  disabled?: boolean,
  theme?: 'white' | 'black',
}

interface OptionData {
  label: string,
  value: string | number | boolean | object,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Select',
  props: {
    value: { type: [String, Number, Boolean, Object] },
    disabled: { type: Boolean },
    theme: null
  },
  emits: ['input', 'change'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  value: string | number | boolean | object,
  disabled?: boolean,
  theme?: 'white' | 'black',
}

const { nextZIndex } = useZIndex();





const showSelectDropdown = ref(false);
const optionArray: Ref<OptionData[]> = ref([]);
const selectedLabel = ref('');
const selectedValue = ref(props.value);
const selectContainerRef = ref();
const selectDropDownRef = ref();
const dropDirection = ref('down');
const themeClass = computed(() => (props.theme ? `tui-theme-${props.theme}` : ''));

watch(() => props.value, (val) => {
  selectedValue.value = val;
  const option = optionArray.value.find(item => item.value === val);
  if (option) {
    selectedLabel.value = option.label;
  }
});

watch(() => optionArray, () => {
  const option = optionArray.value.find(item => item.value === props.value);
  if (option) {
    selectedLabel.value = option.label;
  }
}, { deep: true });

const dropDownStyle = ref({});

function onOptionCreated(option: OptionData) {
  optionArray.value.push(option);
}

function onOptionDestroyed(value: string | number | boolean | object) {
  const index = optionArray.value.findIndex(item => item.value === value);
  optionArray.value.splice(index, 1);
}

function onOptionSelected(option: OptionData) {
  selectedValue.value = option.value;
  showSelectDropdown.value = false;
  emits('input', option.value);
}

watch(selectedValue, (val) => {
  emits('change', val);
});

provide('select', reactive({
  selectedValue,
  onOptionCreated,
  onOptionDestroyed,
  onOptionSelected,
}));

function handleClickSelect() {
  if (props.disabled) {
    return;
  }
  if (showSelectDropdown.value) {
    showSelectDropdown.value = false;
  } else {
    handleDropDownPosition();
    dropDownStyle.value = { zIndex: nextZIndex() };
    showSelectDropdown.value = true;
  }
}

// 根据页面位置确定下拉框的定位
function handleDropDownPosition() {
  const { top, bottom } = selectContainerRef.value?.getBoundingClientRect();
  const bottomSize = document.body.offsetHeight - bottom;
  let dropDownContainerHeight = 0;
  if (!showSelectDropdown.value) {
    selectDropDownRef.value.style = 'display:block;position:absolute;z-index:-1000';
    dropDownContainerHeight = selectDropDownRef.value.offsetHeight;
    selectDropDownRef.value.style = '';
  } else {
    dropDownContainerHeight = selectDropDownRef.value?.offsetHeight;
  }
  if (bottomSize < top && bottomSize < dropDownContainerHeight) {
    dropDirection.value = 'up';
  }
}

function handleClickOutside() {
  if (showSelectDropdown.value) {
    showSelectDropdown.value = false;
  }
}


return { __sfc: true,nextZIndex, props, emits, showSelectDropdown, optionArray, selectedLabel, selectedValue, selectContainerRef, selectDropDownRef, dropDirection, themeClass, dropDownStyle, onOptionCreated, onOptionDestroyed, onOptionSelected, handleClickSelect, handleDropDownPosition, handleClickOutside, SvgIcon, ArrowStrokeSelectDownIcon }
}

})